import React, { useState } from 'react';
import SweetAlert from '../Shared/Notification/index';
import { ConstantActions } from '../../Services/_actions';
import './style.css';
import FileInput from '../Shared/FileUploadPreview/FileInput';
import { Card, Col, Container, Row } from 'react-bootstrap';

const FileUpload = () => {
  const constantActions = ConstantActions();
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState('');

  // Define maximum file sizes in bytes
  const MAX_IMAGE_SIZE = 2 * 1024 * 1024; // 2 MB
  const MAX_VIDEO_SIZE = 20 * 1024 * 1024; // 20 MB
  const MAX_DOCUMENT_SIZE = 5 * 1024 * 1024; // 5 MB (Increased for PDFs)

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];

    if (!selectedFile) return;

    // Validate file size
    if (selectedFile.size > MAX_IMAGE_SIZE && selectedFile.type.startsWith('image')) {
      SweetAlert('Error', 'Image files must be smaller than 2 MB.');
      return;
    }

    if (selectedFile.size > MAX_VIDEO_SIZE && selectedFile.type.startsWith('video')) {
      SweetAlert('Error', 'Video files must be smaller than 20 MB.');
      return;
    }

    if (
      selectedFile.size > MAX_DOCUMENT_SIZE &&
      !selectedFile.type.startsWith('image') &&
      !selectedFile.type.startsWith('video')
    ) {
      SweetAlert('Error', 'Document files must be smaller than 5 MB.');
      return;
    }

    // Validate file type
    if (!['image/jpeg', 'image/png', 'video/mp4', 'application/pdf'].includes(selectedFile.type)) {
      SweetAlert('Error', 'Invalid file type. Accepted types are JPEG, PNG, MP4, and PDF.');
      return;
    }

    setFile(selectedFile);
  };

  const handleUpload = async () => {
    if (!file) {
      SweetAlert('Error', 'Please select a file to upload.');
      return;
    }
    const formDataToUpload = new FormData();
    formDataToUpload.append('file', file);
    // let my_filename = `${Date.now().toString()}${file?.name}`?.replace(/ /g, '_');
    // let updatedFile = new File([file], my_filename, { type: file?.type });
    let resp = await constantActions.uploadFileS3Bucket(updatedFile);
    let link = '';
    console.log(resp, 'resprespresp');
    try {
      // if (resp?.$response?.httpResponse?.statusCode) {
      //   link = `${process.env.REACT_APP_IMAGE_URL}/${my_filename}`;
      //   setUrl(link);
      //   SweetAlert('Success', 'File uploaded successfully!');
      // }

      if (resp?.status === 200 && resp?.data?.data) {
        link = resp?.data?.data?.url ?? '';
        setUrl(link);
        SweetAlert('Success', 'File uploaded successfully!');
      }
    } catch (error) {
      SweetAlert('Error', `Error uploading file: ${error.message}`);
    }
  };

  return (
    <Container fluid className="d-flex vh-50 style-file-upload">
      <Row className="m-auto">
        <Col>
          <Card style={{ width: 'auto', height: '9rem' }}>
            <Card.Body>
              <Card.Title className="mt-1">Upload a File</Card.Title>
              <div className="pt-3 justify-content-center">
                <FileInput
                  onFileSelect={handleFileChange}
                  onFileRemove={() => {
                    setFile(null);
                  }}
                  onFileUpload={handleUpload}
                  file={file}
                  accept="image/jpeg, image/png, video/mp4, application/pdf"
                />
              </div>
              {url && (
                <>
                  <Card.Text>File uploaded successfully!</Card.Text>
                  <Card.Link href="#" onClick={() => navigator.clipboard.writeText(url)}>
                    Copy Url
                  </Card.Link>
                  <Card.Link href={url}>Open Uploaded File</Card.Link>
                </>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default FileUpload;
